export default {
  provide() { // 这里定义provide 传递参数
    return {
      data: this.data || [], // 表格数据
      pagination: this.pagination // 分页属性
    }
  },
  data() {
    return {
      data: [],
      pagination: {
        page: 1,
        total: 20,
        per_page: 10
      }
    }
  },
  methods: {
    onGotPageData({ list, total, per_page, current_page }) { // 根据内容解构 等接口
      this.data = list
      this.pagination.page = current_page
      this.pagination.per_page = per_page
      this.pagination.total = total
    },
    onPageChanged({ page, per_page }) {

      this.pagination.page = page
      this.pagination.per_page = per_page
      if (this.query) {
        this.query()
      }
    },
    addPageInfo(params = {}) {
      Object.assign(params, {
        per_page: this.pagination.per_page,
        page: this.pagination.page
      })
      return params
    }
  }
}
